<div class="content">

  <app-navbar></app-navbar>

  <!-- SECONDARY BAR -->
  <div class="secondary-nav">
    <!-- MOBILE MENU BUTTON -->
    <div class="mobile-menu-btn d-md-none">
      <button (click)="toggleSidebar()">
        <i class="fa-solid fa-ellipsis-v fa-lg"></i>
      </button>
    </div>
    <div class="secondary-container container">

      <div class="secondary-left">

        <a class="secondary-link">
          <i [class]="activeMenuIcon"></i>
          {{ activeMenuTitle }}
        </a>

      </div>
    </div>
  </div>

  <div class="dashboard-body">
    <div class="row g-0 dashboard-layout">



      <!-- BACKDROP -->
      <div class="sidebar-backdrop" *ngIf="isSidebarOpen" (click)="closeSidebar()"></div>

      <!-- SIDEBAR -->
      <div class="col-md-2 sidebar-wrapper" [ngClass]="{ 'sidebar-open': isSidebarOpen }">

        <div class="sidebar pt-4">

          <!-- SIDEBAR NAVIGATION -->
          <div class="sidebar-nav">

            <a routerLink="/dashboard/user-profile" routerLinkActive="active" class="sidebar-item"
              (click)="setActiveMenu('User Profile','fa-regular fa-user'); closeSidebarOnMobile()">
              <i class="fa-regular fa-user"></i>
              User Profile
            </a>

            <a *ngIf="showAdminComponents || showBrokerAdminComponents" routerLink="/dashboard/user-management"
              routerLinkActive="active" class="sidebar-item"
              (click)="setActiveMenu('User Management','fas fa-users'); closeSidebarOnMobile()">
              <i class="fas fa-users"></i>
              User Management
            </a>

            <a *ngIf="showAdminComponents" routerLink="/dashboard/user-pending-request" routerLinkActive="active"
              class="sidebar-item"
              (click)="setActiveMenu('Pending Request','fas fa-hourglass-half'); closeSidebarOnMobile()">
              <i class="fas fa-hourglass-half"></i>
              Pending Request
            </a>

            <a *ngIf="!showAdminComponents" routerLink="/dashboard/change-password" routerLinkActive="active"
              class="sidebar-item" (click)="setActiveMenu('Change Password','fa-solid fa-key'); closeSidebarOnMobile()">
              <i class="fa-solid fa-key"></i>
              Change Password
            </a>

            <a *ngIf="showAdminComponents || showSysAdminComponents || showInternalUserComponents"
              routerLink="/dashboard/monitoring-dashboard" routerLinkActive="active" class="sidebar-item"
              (click)="setActiveMenu('API Usage','fa-solid fa-chart-area'); closeSidebarOnMobile()">
              <i class="fa-solid fa-chart-area"></i>
              API Usage
            </a>

            <a *ngIf="showAdminComponents" routerLink="/dashboard/maintenance-scheduling" routerLinkActive="active"
              class="sidebar-item"
              (click)="setActiveMenu('Maintenance Scheduling','fa-solid fa-calendar'); closeSidebarOnMobile()">
              <i class="fa-solid fa-calendar"></i>
              Maintenance Scheduling
            </a>

            <a *ngIf="isAllowedUrlIssuerRole" routerLink="/dashboard/generate-presigned-url" routerLinkActive="active"
              class="sidebar-item"
              (click)="setActiveMenu('Institution API Access Key Generator','fa-solid fa-link'); closeSidebarOnMobile()">
              <i class="fa-solid fa-link"></i>
              Institution API Access Key Generator
            </a>

            <a *ngIf="showAdminComponents" routerLink="/dashboard/institution-app-data" routerLinkActive="active"
              class="sidebar-item"
              (click)="setActiveMenu('Institution API Access Information','fa-solid fa-gear'); closeSidebarOnMobile()">
              <i class="fa-solid fa-gear"></i>
              Institution API Access Information
            </a>

<!--            <a *ngIf="showAdminComponents" routerLink="/dashboard/configurations" routerLinkActive="active"-->
<!--              class="sidebar-item"-->
<!--              (click)="setActiveMenu('Institution Configuration','fa-solid fa-sliders'); closeSidebarOnMobile()">-->
<!--              <i class="fa-solid fa-sliders"></i>-->
<!--              Institution Configuration-->
<!--            </a>-->

            <a *ngIf="showAdminComponents" routerLink="/dashboard/upload-confluence-document" routerLinkActive="active"
              class="sidebar-item"
              (click)="setActiveMenu('Upload Confluence Document','fa-solid fa-file-zipper'); closeSidebarOnMobile()">
              <i class="fa-solid fa-file-zipper"></i>
              Upload Confluence Document
            </a>

          </div>

        </div>
      </div>

      <!-- MAIN CONTENT -->
      <div class="col-md-10 dashboard-content">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>
